import { css, styled } from '../theme';
import { Side } from './hint.types';
import {
  overlaySlideInBottom,
  overlaySlideInLeft,
  overlaySlideInRight,
  overlaySlideInTop,
  overlaySlideOutBottom,
  overlaySlideOutLeft,
  overlaySlideOutRight,
  overlaySlideOutTop,
} from '../_core/animations/slide';

export const TriggerWrapper = styled.span`
  display: inline-flex;
  outline: none;
  position: relative;
  z-index: 10000;
`;

export const ContentWrapper = styled.div<{ $side: Side; $open: boolean }>`
  ${({ theme, $open, $side }) => css`
    position: fixed;
    z-index: 9999;
    pointer-events: auto;

    padding: ${theme.spacings.xs};
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    border-radius: ${theme.radiuses.xxs};
    max-width: 300px;
    border: 1px solid ${theme.colors.black};
    animation-duration: ${$open ? '200ms' : '150ms'};
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    animation-fill-mode: forwards;

    ${{
      top: css`
        animation-name: ${$open ? overlaySlideInTop : overlaySlideOutTop};
      `,
      bottom: css`
        animation-name: ${$open ? overlaySlideInBottom : overlaySlideOutBottom};
      `,
      left: css`
        animation-name: ${$open ? overlaySlideInLeft : overlaySlideOutLeft};
      `,
      right: css`
        animation-name: ${$open ? overlaySlideInRight : overlaySlideOutRight};
      `,
    }[$side]}

    @media (prefers-reduced-motion: reduce) {
      animation-duration: 1ms;
    }
  `}
`;

export const Arrow = styled.div<{ $side: Side; $offset?: number }>`
  ${({ theme, $side, $offset = 0 }) => css`
    position: absolute;
    width: 12px;
    height: 12px;
    background: ${theme.colors.black};
    border: 1px solid ${theme.colors.black};
    border-radius: ${theme.radiuses.xxxs};
    transform: rotate(45deg);

    ${{
      top: css`
        bottom: -5px;
        left: ${$offset}px;
        margin-left: -4px;
        border-top: none;
        border-left: none;
      `,
      bottom: css`
        top: -5px;
        left: ${$offset}px;
        margin-left: -4px;
        border-bottom: none;
        border-right: none;
      `,
      left: css`
        right: -5px;
        top: ${$offset}px;
        margin-top: -4px;
        border-top: none;
        border-right: none;
      `,
      right: css`
        left: -5px;
        top: ${$offset}px;
        margin-top: -4px;
        border-bottom: none;
        border-left: none;
      `,
    }[$side]}
  `}
`;
